module.exports = __webpack_public_path__ + "static/Scrum_board-885dc68bf623fcf56cd981b084d93006.svg";